import { datahubApi } from 'components/conversation/components/integrations/elevio/src/apis/graphQl/elevio/data/datahub.api';
import { grappaApi } from 'components/conversation/components/integrations/elevio/src/apis/graphQl/elevio/grappa/grappa.api';

export const elevioApi = {
  grappa: grappaApi, // GraphQL API
  datahub: datahubApi, // GraphQL API
};

export const elevioApiReducers = {
  [elevioApi.grappa.reducerPath]: elevioApi.grappa.reducer,
  [elevioApi.datahub.reducerPath]: elevioApi.datahub.reducer,
};

export const elevioApiMiddleware = [
  elevioApi.grappa.middleware,
  elevioApi.datahub.middleware,
];
